import { ReactElement, useMemo } from 'react'
import { SceneLineMarker } from '@scene'
import { useTheme } from '@mui/material'

interface Props {
  /** The band's four corners, in order around it. */
  points: { x: number; y: number; z: number }[]
}

/**
 * The outline of the band marking the selected shear anchor on its wall (see
 * `getShearAnchorBandPoints`). Drawn without depth test so it stays visible behind other elements.
 */
const ShearAnchorBandSceneMarker = ({ points }: Props): ReactElement => {
  const { scenePalette } = useTheme()

  const lines = useMemo(
    () => points.map((point, index) => [point, points[(index + 1) % points.length]]),
    [points],
  )

  return (
    <SceneLineMarker
      lines={lines}
      color={scenePalette.selection as string}
      lineWidth={3}
      disableDepthTest
    />
  )
}

export default ShearAnchorBandSceneMarker
